/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Ocop_Issuer_Provincial1Inputs */

const vi_sitesettings_ocop_issuer_provincial1 = /** @type {(inputs: Sitesettings_Ocop_Issuer_Provincial1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị chứng nhận cấp tỉnh`)
};

/**

* @param {Sitesettings_Ocop_Issuer_Provincial1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_ocop_issuer_provincial1 = /** @type {((inputs?: Sitesettings_Ocop_Issuer_Provincial1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Ocop_Issuer_Provincial1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_ocop_issuer_provincial1(inputs)
});
export { sitesettings_ocop_issuer_provincial1 as "siteSettings_ocop_issuer_provincial" }